// ============================================================
// dom.js — All DOM element references
// ============================================================
// NOTE: This module MUST be imported after the DOM is ready
// (e.g. from a <script> at the end of <body>, or inside a
// DOMContentLoaded handler).  Every document.getElementById /
// querySelector call that was at the top level of the original
// script is collected here.
// ============================================================

// --- Cursor & Plushie ---
const cursor              = document.getElementById('cursor');
const smiley              = document.getElementById('smiley');

// --- Score / Combo display ---
const scoreEl             = document.getElementById('score');
const comboEl             = document.getElementById('combo');
const scoreDisplay        = document.getElementById('score-display');
const clickPowerDisplay   = document.getElementById('click-power');

// --- Settings panel ---
const settingsBtn         = document.getElementById('settings-btn');
const settingsEl          = document.getElementById('settings');
const settingsCloseBtn    = document.getElementById('settings-close');
const toggleMusic         = document.getElementById('toggle-music');
const musicVolumeRow      = document.getElementById('music-volume-row');
const musicVolumeSlider   = document.getElementById('music-volume');
const toggleSfx           = document.getElementById('toggle-sfx');
const srcMp3              = document.getElementById('src-mp3');
const srcOg               = document.getElementById('src-og');

// --- Badge panel ---
const badgeBtn            = document.getElementById('badge-btn');
const badgePanel          = document.getElementById('badge-panel');
const badgeClose          = document.getElementById('badge-close');
const badgeGrid           = document.getElementById('badge-grid');

// --- Continue overlay ---
const continueOverlay     = document.getElementById('continue-overlay');
const continueMain        = document.getElementById('continue-main');
const continueSameBtn     = document.getElementById('continue-same');
const continueOtherBtn    = document.getElementById('continue-other');
const continueConfirm     = document.getElementById('continue-confirm');
const confirmGoBackBtn    = document.getElementById('confirm-go-back');
const confirmProceedBtn   = document.getElementById('confirm-proceed');

// --- Pause system ---
const pauseBtn            = document.getElementById('pause-btn');
const pauseOverlay        = document.getElementById('pause-overlay');
const resumeBtn           = document.getElementById('resume-btn');
const countdownOverlay    = document.getElementById('countdown-overlay');
const countdownNumber     = document.getElementById('countdown-number');
const saveMenuBtn         = document.getElementById('save-menu-btn');
const exitWarningOverlay  = document.getElementById('exit-warning-overlay');
const exitWarningCancel   = document.getElementById('exit-warning-cancel');
const exitWarningConfirm  = document.getElementById('exit-warning-confirm');

// --- Eye Boss ---
const eyeBossOverlay      = document.getElementById('eye-boss-overlay');
const eyeBossVignette     = document.getElementById('eye-boss-vignette');
const eyeBossEl           = document.getElementById('eye-boss');
const eyeBossText         = document.getElementById('eye-boss-text');
const eyeBossHp           = document.getElementById('eye-boss-hp');
const eyeBossHpWrap       = document.getElementById('eye-boss-hp-wrap');

// --- Phase warnings ---
const phase3Warning       = document.getElementById('phase3-warning');
const phase4Warning       = document.getElementById('phase4-warning');
const phase5Warning       = document.getElementById('phase5-warning');
const frozenWarningEl     = document.getElementById('frozen-warning');
const warningEl           = document.getElementById('warning');

// --- Escape / Win ---
const escapeProgress      = document.getElementById('escape-progress');
const winScreen           = document.getElementById('win-screen');
const winScoreEl          = document.getElementById('win-score');
const winNewCharBtn       = document.getElementById('win-new-char-btn');
const winMenuBtn          = document.getElementById('win-menu-btn');

// --- Character selection ---
const charSelect          = document.getElementById('char-select');
const charCards           = document.querySelectorAll('.char-card');
const charWaineSelect     = document.getElementById('char-waine-select');
const charSecretSelect    = document.getElementById('char-secret-select');

// --- Shop panel ---
const shopBtn             = document.getElementById('shop-btn');
const shopEl              = document.getElementById('shop');
const shopCloseBtn        = document.getElementById('shop-close');

const shopClickPower      = document.getElementById('shop-click-power');
const clickPowerPriceEl   = document.getElementById('click-power-price');
const clickPowerLevelEl   = document.getElementById('click-power-level');
const clickPowerBoughtEl  = document.getElementById('click-power-bought');

const shopAutoClicker     = document.getElementById('shop-auto-clicker');
const autoClickerPriceEl  = document.getElementById('auto-clicker-price');
const autoClickerLevelEl  = document.getElementById('auto-clicker-level');
const autoClickerBoughtEl = document.getElementById('auto-clicker-bought');

const shopAutoSpeed       = document.getElementById('shop-auto-speed');
const autoSpeedPriceEl    = document.getElementById('auto-speed-price');
const autoSpeedLevelEl    = document.getElementById('auto-speed-level');
const autoSpeedBoughtEl   = document.getElementById('auto-speed-bought');

const shopMegaClick       = document.getElementById('shop-mega-click');
const megaClickPriceEl    = document.getElementById('mega-click-price');
const megaClickLevelEl    = document.getElementById('mega-click-level');
const megaClickBoughtEl   = document.getElementById('mega-click-bought');

// --- Effects wrappers ---
const fireWrap            = document.getElementById('fire-wrap');
const abstractionBg       = document.getElementById('abstraction-bg');

// --- Auth modal extras ---
const authModalCloseBtn   = document.getElementById('auth-modal-close');
const authDisplayName     = document.getElementById('auth-displayname');
const authForgotBtn       = document.getElementById('auth-forgot-btn');
const authSubmitSignin    = document.getElementById('submit-signin');
const authResetForm       = document.getElementById('auth-reset-form');
const authResetEmail      = document.getElementById('auth-reset-email');
const authResetCancel     = document.getElementById('auth-reset-cancel');
const authResetMsg        = document.getElementById('auth-reset-msg');
const authSubmitReset     = document.getElementById('submit-reset');
const authNewpwForm       = document.getElementById('auth-newpw-form');
const authNewpw           = document.getElementById('auth-newpw');
const authNewpwMsg        = document.getElementById('auth-newpw-msg');
const authSubmitNewpw     = document.getElementById('submit-newpw');

// --- Phase 3 audio element ---
// Phase 3 (Abstraction, 3500+) swaps out the chill background for a
// darker loop.  manager.js / phase3.js / phase4.js / phase5.js all
// interact with this element via play()/pause()/volume/currentTime.
const phase3Audio         = new Audio('/music/music.mp3');
phase3Audio.loop          = true;
phase3Audio.volume        = 0.5;

// --- Game over ---
const gameOverEl          = document.getElementById('game-over');
const finalScoreEl        = document.getElementById('final-score');
const retryBtn            = document.getElementById('retry-btn');

// --- Loading screen & Main menu ---
const loadingScreen       = document.getElementById('loading-screen');
const loadingBar          = document.getElementById('loading-bar');
const loadingCharImg      = document.getElementById('loading-char-img');
const mainMenu            = document.getElementById('main-menu');
const menuPlayBtn         = document.getElementById('menu-play');
const menuSettingsBtn     = document.getElementById('menu-settings');
const menuBadgesBtn       = document.getElementById('menu-badges');
const menuCreditsBtn      = document.getElementById('menu-credits');
const menuLeaderboardBtn  = document.getElementById('menu-leaderboard');
const creditsOverlay      = document.getElementById('credits-overlay');
const creditsCloseBtn     = document.getElementById('credits-close');
const leaderboardOverlay  = document.getElementById('leaderboard-overlay');
const leaderboardList     = document.getElementById('leaderboard-list');
const leaderboardCloseBtn = document.getElementById('leaderboard-close');

// --- Mode selection ---
const modeSelect          = document.getElementById('mode-select');
const modeNormal          = document.getElementById('mode-normal');
const modeCompetitive     = document.getElementById('mode-competitive');
const livesDisplay        = document.getElementById('lives-display');
const highScoreDisplay    = document.getElementById('high-score');
const highScoreVal        = document.getElementById('high-score-val');

// --- Derived values ---
// The default plushie <img> src, captured once at startup.
const defaultPlushieSrc   = smiley.querySelector('img').src;

// --- Background music Audio element (not a DOM query, but shared) ---
const bgMusic             = new Audio('/music/CHILL MUSIC.mp3');
bgMusic.loop              = true;
bgMusic.volume            = 0.5;

// ============================================================
// Single export object
// ============================================================
export const dom = {
  cursor,
  smiley,
  scoreEl,
  comboEl,
  scoreDisplay,
  clickPowerDisplay,

  continueOverlay,
  continueMain,
  continueSameBtn,
  continueOtherBtn,
  continueConfirm,
  confirmGoBackBtn,
  confirmProceedBtn,

  settingsBtn,
  settingsEl,
  settingsCloseBtn,
  toggleMusic,
  musicVolumeRow,
  musicVolumeSlider,
  toggleSfx,
  srcMp3,
  srcOg,

  badgeBtn,
  badgePanel,
  badgeClose,
  badgeGrid,

  pauseBtn,
  pauseOverlay,
  resumeBtn,
  countdownOverlay,
  countdownNumber,
  saveMenuBtn,
  exitWarningOverlay,
  exitWarningCancel,
  exitWarningConfirm,

  eyeBossOverlay,
  eyeBossVignette,
  eyeBossEl,
  eyeBossText,
  eyeBossHp,
  eyeBossHpWrap,

  phase3Warning,
  phase4Warning,
  phase5Warning,
  frozenWarningEl,
  warningEl,

  escapeProgress,
  winScreen,
  winScoreEl,
  winNewCharBtn,
  winMenuBtn,

  charSelect,
  charCards,
  charWaineSelect,
  charSecretSelect,

  shopBtn,
  shopEl,
  shopCloseBtn,
  shopClickPower,
  clickPowerPriceEl,
  clickPowerLevelEl,
  clickPowerBoughtEl,
  shopAutoClicker,
  autoClickerPriceEl,
  autoClickerLevelEl,
  autoClickerBoughtEl,
  shopAutoSpeed,
  autoSpeedPriceEl,
  autoSpeedLevelEl,
  autoSpeedBoughtEl,
  shopMegaClick,
  megaClickPriceEl,
  megaClickLevelEl,
  megaClickBoughtEl,

  authModalCloseBtn,
  authDisplayName,
  authForgotBtn,
  authSubmitSignin,
  authResetForm,
  authResetEmail,
  authResetCancel,
  authResetMsg,
  authSubmitReset,
  authNewpwForm,
  authNewpw,
  authNewpwMsg,
  authSubmitNewpw,

  fireWrap,
  abstractionBg,
  phase3Audio,

  gameOverEl,
  finalScoreEl,
  retryBtn,

  loadingScreen,
  loadingBar,
  loadingCharImg,
  mainMenu,
  menuPlayBtn,
  menuSettingsBtn,
  menuBadgesBtn,
  menuCreditsBtn,
  menuLeaderboardBtn,
  creditsOverlay,
  creditsCloseBtn,
  leaderboardOverlay,
  leaderboardList,
  leaderboardCloseBtn,

  modeSelect,
  modeNormal,
  modeCompetitive,
  livesDisplay,
  highScoreDisplay,
  highScoreVal,

  bgMusic,
};

/**
 * Close all "mutually exclusive" panels (shop, settings, badges,
 * leaderboard, credits). Call this BEFORE opening a new one so only
 * one panel is ever visible at a time.
 */
export function closeAllPanels() {
  shopEl.classList.remove('open');
  settingsEl.classList.remove('open');
  badgePanel.classList.remove('open');
  leaderboardOverlay.classList.remove('show');
  creditsOverlay.classList.remove('show');
}

export { defaultPlushieSrc };
